<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="aafb/admin/item/"
                       :extra-params="{
                         location_id: locationId,
                         region_id: regionId,
                         type_id: typeId,
                       }"
                       data-key="items"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template v-slot:item.actions="{item}">
      <v-menu offset-y
              rounded
              left>
        <template v-slot:activator="{on}">
          <v-btn icon
                 v-on="on">
            <v-icon>fas fa-cog</v-icon>
          </v-btn>
        </template>
        <v-list class="pa-2">
          <v-list-item @click="editItem(item)">
            <v-icon>fas fa-search</v-icon>
            <label class="ml-3 font-weight-medium">{{ $t('detail') }}</label>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";

export default {
  name: 'ItemList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
    typeId: String,
    locationId: String,
    regionId: String,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;

      getItemTypes();
      getLocations();
      getRegions();
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const itemTypes = ref([]);
    const getItemTypes = function () {
      if (!props.typeId) {
        root.$callAPI('aafb/admin/item_type/', {}, function (response) {
          itemTypes.value = response.body.item_types;
        })
      }
    };

    const locations = ref([]);
    const getLocations = function () {
      if (!props.locationId && !props.regionId) {
        root.$callAPI('aafb/admin/location/', {}, function (response) {
          locations.value = response.body.locations;
        })
      }
    }

    const regions = ref([]);
    const getRegions = function () {
      if (!props.regionId) {
        root.$callAPI('aafb/admin/region/', {location_id: props.locationId}, function (response) {
          regions.value = response.body.regions;
        });
      }
    }

    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_acc_item.name_en'), value: 'name_en', contains: true},
        {text: root.$t('admin_acc_item.name_zh'), value: 'name_zh', contains: true},
        ...(props.typeId ? [] : [{
          text: root.$t('admin_acc_item.item_type'), value: 'type.id',
          options: itemTypes.value.map((t) => {
            return {text: t.name, value: t.id};
          }),
        }]),

        ...(props.locationId ? [] : [{
          text: root.$t('admin_acc_item.location'), value: 'region.location.id',
          options: locations.value.map((t) => {
            return {text: t.name, value: t.id};
          }),
        }]),

        ...(props.regionId ? [] : [{
          text: root.$t('admin_acc_item.region'), value: 'region.id',
          options: regions.value.map((t) => {
            return {text: t.name, value: t.id};
          }),
        }]),
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_acc_item.name_en'), value: 'name_en'},
      {text: root.$t('admin_acc_item.name_zh'), value: 'name_zh'},
      {text: root.$t('admin_acc_item.item_type'), value: 'type.name'},
      {text: '', value: 'actions'},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const editItem = function (item) {
      emit('edit', item);
    };


    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
    }
  }
}
</script>
